export default __webpack_public_path__ + "static/media/website-videos.de769b18.svg";